<script setup lang="ts">
import { useStore } from '@/stores/store'
import { storeToRefs } from 'pinia'
import { Field } from 'vee-validate'

const store = useStore()
const topStitchesSingle = store.imgPath + '/shapes/top-stitches-single.jpg'
const topStitchesDouble = store.imgPath + '/shapes/top-stitches-double.jpg'
const { topStitchesType, isStitches } = storeToRefs(store)
</script>
<template>
  <transition name="modal">
    <div class="modal-mask" v-if="isStitches === 'stitches_yes'">
      <fieldset class="form-padding space-y-2">
        <legend class="field-label">
          {{ $t('Please choose type of top sewings') }}
        </legend>
        <div class="form-part stitches-part flex gap-4">
          <label class="shape-item" for="top_stitches_single">
            <div class="distribution-sample">
              <img :src="topStitchesSingle" />
            </div>
            <div class="shape-wrapper">
              <Field
                name="topStitchesType"
                type="radio"
                v-model="topStitchesType"
                v-slot="{ field }"
              >
                <input
                  id="top_stitches_single"
                  v-bind="field"
                  required
                  type="radio"
                  class="radio-input"
                  value="top_stitches_single"
                  name="topStitchesType"
                />
              </Field>
              <span class="check-text">{{ $t('Single') }}</span>
            </div>
          </label>
          <label class="shape-item" for="top_stitches_double">
            <div class="distribution-sample">
              <img :src="topStitchesDouble" />
            </div>
            <div class="shape-wrapper">
              <Field
                name="topStitchesType"
                type="radio"
                v-model="topStitchesType"
                v-slot="{ field }"
              >
                <input
                  id="top_stitches_double"
                  v-bind="field"
                  required
                  type="radio"
                  class="radio-input"
                  value="top_stitches_double"
                  name="topStitchesType"
                />
              </Field>
              <span class="check-text">{{ $t('Double') }}</span>
            </div>
          </label>
        </div>
      </fieldset>
    </div>
  </transition>
</template>

<style scoped></style>
